import React, { FC } from 'react';

import { SxProps, TableCell, TableRow, Theme } from '@mui/material';

import { TStatusType } from 'shared/services/types/common.types';
import { TWithdrawal } from 'shared/services/types/withdrawal.types';
import { MethodTableLayout } from 'shared/ui/method-table-layout';
import { Status } from 'shared/ui/status';
import { TableContentWrapper } from 'shared/ui/table-content-wrapper';
import { getTransformedDate } from 'shared/utils';

import { COLUMNS_WITHDRAWALS } from '../mock-data/COL_WITHDRAWALS';

interface IProps {
  size: number;
  setSize: React.Dispatch<React.SetStateAction<number>>;
  withdrawalData?: TWithdrawal.WithdrawalResponse;
  isWithdrawalLoading: boolean;
}

const customStyles = {
  tableLayout: 'fixed',
  p: '12px 16px',
  position: 'absolute',
  top: '0',
  left: '0',
  '.MuiTableCell-root:first-child': {
    paddingLeft: '0px !important'
  },
  '.MuiTableRow-head': {
    '.MuiTableCell-head': {
      paddingTop: '4px',
      paddingBottom: '10px'
    }
  }
} as SxProps<Theme>;

export const WithdrawalTables: FC<IProps> = ({
  size,
  setSize,
  withdrawalData,
  isWithdrawalLoading
}) => {
  return (
    <MethodTableLayout
      pageSize={size}
      setPageSize={setSize}
      isDataLoading={isWithdrawalLoading}
      sx={{
        '&.MuiBox-root': {
          gridRow: '2/4'
        },
        '.MuiTableBody-root': {
          '.MuiTableRow-root': {
            '.MuiTableCell-root': {
              borderBottom: '1px solid var(--mui-palette-divider)'
            }
          }
        }
      }}
      total={withdrawalData?.total || 0}>
      <TableContentWrapper columns={COLUMNS_WITHDRAWALS} sx={customStyles}>
        {withdrawalData?.items?.map((row, id) => {
          const status = row?.status as TStatusType;
          return (
            <TableRow key={id}>
              <TableCell align='left' sx={{ '.MuiStack-root': { margin: 0 } }}>
                <Status status={status} />
              </TableCell>
              <TableCell align='left'>{row.role}</TableCell>
              <TableCell align='left'>{row.id}</TableCell>
              <TableCell align='left'>{row.id_transaction}</TableCell>
              <TableCell align='left'>{row.subagent_id}</TableCell>
              <TableCell align='left'>{row.amount}</TableCell>
              <TableCell align='left'>{row.account_id_from}</TableCell>
              <TableCell align='left'>{row.account_id_to}</TableCell>
              <TableCell align='left'>{getTransformedDate(row?.created_at)}</TableCell>
            </TableRow>
          );
        })}
      </TableContentWrapper>
    </MethodTableLayout>
  );
};
